// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Lf63","small":"Button_small__1WqE1","buttonGroup":"Button_buttonGroup__STPop","active":"Button_active__h0ecc"};